import { endpoints } from "../../services/endpoint.ts/endpoint";
import { RequestParam } from "../../utils/contact";
import { getData, putData, deleteData, postGroupData } from "../api/action";

export const getUser = async (payload) => {
  const response = await getData({
    url: `${endpoints.GET_USER.url}/${payload.username}`,
  });
  // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 반환
  return response;
};

export const updateUser = async (payload) => {
  const response = await putData(
    { url: `${endpoints.UPDATE_USER.url}/${payload.id}` },
    payload
  );
  return response;
};

export const updatePassword = async (payload) => {
  const response = await putData(
    { url: `${endpoints.UPDATE_PASSWORD.url}/${payload.id}` },
    payload
  );
  return response;
};

export const getUserList = async (payload) => {
  // console.log("getUserList payload ["+JSON.stringify(payload)+"]");
  const response = await getData({
    url: `${endpoints.GET_USER_LIST.url}?${RequestParam(payload)}`,
  });
  // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 반환
  return response;
};

export const removeUser = async (id) => {
  const response = await deleteData({
    url: `${endpoints.REMOVE_USER.url}/${id}`,
  });
  return response;
};

export const updateUserPassword = async (payload) => {
  const response = await putData(
    { url: `${endpoints.UPDATE_USER_PASSWORD.url}/${payload.id}` },
    { password: payload.password }
  );
  return response;
};

export const getGroup = async (payload) => {
  const response = await getData({
    url: `${endpoints.GET_GROUP.url}/${payload.id}`,
  });
  // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 반환
  return response;
};

export const getGroupList = async () => {
  const response = await getData({
    url: `${endpoints.GET_GROUP_LIST.url}`,
  });
  // getRequestWithHeader가 이미 response.data를 반환하므로 response를 그대로 반환
  return response;
};

export const createGroup = async (payload) => {
  // console.log("createGroup payload ["+JSON.stringify(payload)+"]");
  const response = await postGroupData(
    { 
      url: endpoints.CREATE_GROUP.url,
      headers: {
        'Content-Type': 'application/json'
      }
    }, 
    payload
  );
  
  return response;
};

export const removeGroup = async (id) => {
  const response = await deleteData({
    url: `${endpoints.REMOVE_GROUP.url}/${id}`,
  });
  return response;
};
